import * as React from "react";

import { cn } from "../../../utils";

export interface ListContainerProps {
  className?: string;
  isLeftExpanded: boolean;
  children: React.ReactNode;
}

const ListContainer: React.FC<ListContainerProps> = ({ className, isLeftExpanded, children }) => {
  return (
    <div
      className={cn(
        "h-[calc(100vh-140px)] min-w-full overflow-hidden rounded-2xl border border-slate-300 bg-white shadow-lg transition-all duration-300 ease-in-out",
        {
          "w-full": isLeftExpanded,
          "md:w-full": isLeftExpanded,
          "w-full lg:w-1/2": !isLeftExpanded
        },
        className
      )}
      style={{
        position: "relative",
        transitionProperty: "width, transform",
        transitionDuration: "300ms"
      }}
    >
      {children}
    </div>
  );
};

export default ListContainer;
